@import 'core';

$ads-card-content-font-size: 16px;
$ads-card-content-padding: 1rem;

:host {
  box-sizing: border-box;
  width: 100%;

  *,
  *::before,
  *::after {
    box-sizing: border-box;
  }

  .c-card-content {
    box-sizing: border-box;
    color: var(--ads-card-content-color, $ads-card-content-color);
    display: block;
    font-family: var(--ads-font-family);
    font-size: var(--ads-card-content-font-size, $ads-card-content-font-size);
    height: 100%;
    overflow: hidden;
    padding: var(--ads-card-content-padding, $ads-card-content-padding);
    position: relative;
    width: inherit;
  }
}
